<div
  *ngIf="dataIsReady"
  [ngClass]="input.type === 'generate' ? 'status-card-generate' : 'status-card'"
  (click)="select()"
  id="no-diet-box"
>
  <div *ngIf="input.type !== 'cheatDay'" class="status-card-icon-holder">
    <img class="status-card-icon" src="{{ input.icon }}" />
  </div>
  <div *ngIf="input.type === 'daily'" class="status-card-fasting-chart-holder">
    <app-plan-status-fasting-chart
      [dataIsReady]="dataIsReady"
      [type]="'daily'"
      [isFasting]="input.isFasting"
    ></app-plan-status-fasting-chart>
  </div>
  <div *ngIf="input.type === 'hourly'" class="status-card-fasting-chart-holder">
    <app-plan-status-fasting-chart
      [dataIsReady]="dataIsReady"
      [type]="'hourly'"
      [isFasting]="input.isFasting"
      [duration]="input.duration"
      [endTime]="input.endTime"
    ></app-plan-status-fasting-chart>
  </div>
  <img
    *ngIf="input.type === 'cheatDay'"
    class="status-card-icon-cheatday"
    src="{{ input.icon }}"
  />
  <div
    class="status-card-title"
    [ngStyle]="{
      color: input.type === 'generate' ? 'white' : 'black',
      width:
        input.type === 'daily' || input.type === 'hourly'
          ? 'calc( 100% - 136px )'
          : 'calc( 100% - 120px )',
      right: input.type === 'daily' || input.type === 'hourly' ? '90px' : '74px'
    }"
  >
    {{ input.title }}
  </div>
  <div
    class="status-card-description"
    [ngStyle]="{
      color: input.type === 'generate' ? 'white' : 'rgb(110, 110, 110)',
      right: input.type === 'daily' || input.type === 'hourly' ? '90px' : '74px'
    }"
  >
    {{ input.description }}
  </div>
  <div
    *ngIf="input.hasMore"
    class="status-card-more-holder"
    [ngStyle]="{
      background:
        input.type === 'generate' ? 'rgb(255, 255, 255)' : 'rgb(0, 115, 255)'
    }"
  >
    <img
      *ngIf="input.type === 'generate'"
      class="status-card-more"
      src="assets/general/left-blue.svg"
    />
    <img
      *ngIf="input.type !== 'generate'"
      class="status-card-more"
      src="assets/general/left-white.svg"
    />
  </div>
</div>
<div *ngIf="!dataIsReady" class="status-card">
  <ngx-skeleton-loader
    *ngIf="!dataIsReady"
    appearance="circle"
    [theme]="{
      top: '20px',
      right: '16px',
      height: '40px',
      width: '40px',
      position: 'absolute',
      margin: '0'
    }"
  ></ngx-skeleton-loader>
  <ngx-skeleton-loader
    *ngIf="!dataIsReady"
    [theme]="{
      top: '10px',
      right: '74px',
      height: '30px',
      width: '150px',
      position: 'absolute'
    }"
  ></ngx-skeleton-loader>
  <ngx-skeleton-loader
    *ngIf="!dataIsReady"
    [theme]="{
      top: '44px',
      right: '74px',
      height: '24px',
      width: '100px',
      position: 'absolute'
    }"
  ></ngx-skeleton-loader>
</div>
